var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecommendation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.48975 8.50651H1.49463V16.4935H4.48975V8.50651Z",
    stroke: "#CED4DA",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49463 16.5H13.3946C13.8496 16.4999 14.2909 16.3447 14.6458 16.06C15.0007 15.7753 15.2479 15.3781 15.3466 14.934L16.4576 9.934C16.5227 9.64133 16.5211 9.33778 16.453 9.04579C16.3849 8.75381 16.2521 8.48088 16.0643 8.24717C15.8765 8.01347 15.6385 7.82498 15.368 7.69565C15.0975 7.56632 14.8014 7.49945 14.5016 7.5H10.4946V3.5C10.4946 2.96957 10.2839 2.46086 9.90884 2.08579C9.53377 1.71071 9.02506 1.5 8.49463 1.5L6.49463 7.5",
    stroke: "#CED4DA",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommendation);
export default __webpack_public_path__ + "static/media/recommendation.32fb17a214130011ba27ebf014a95eaf.svg";
export { ForwardRef as ReactComponent };